import { render, staticRenderFns } from "./goodsdata.vue?vue&type=template&id=73725769"
import script from "./goodsdata.vue?vue&type=script&lang=js"
export * from "./goodsdata.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports